import React, {useState, useMemo, useCallback} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import {useMediaQuery} from "react-responsive";
import Snuggle from "react-snuggle";

import styles from "./sub-menus.module.scss";
import chevronIcon from "../../assets/chevron.svg";

const escKey = 27;

function MasonryLayout({children, isFocused, isDesktop}) {
  return isFocused && isDesktop ? (
    <Snuggle columnWidth={175}>{children}</Snuggle>
  ) : (
    children
  );
}

MasonryLayout.propTypes = {
  children: PropTypes.array,
  isFocused: PropTypes.bool,
  isDesktop: PropTypes.bool
};

export function SubMenus({subMenus, isFocused, hide, keepFocused}) {
  const [opened, setOpened] = useState(-1);
  const isDesktop = useMediaQuery({minWidth: 940});

  const hideOnEsc = useCallback(
    (e) => {
      if (e.which === escKey) {
        hide();
      }
    },
    [hide]
  );

  const onClickHandler = useCallback(
    (index) => {
      setOpened(index === opened ? -1 : index);
    },
    [opened]
  );

  const subMenusEl = useMemo(
    () =>
      subMenus.map((subMenu, index) => (
        <div key={subMenu.title} className={styles.subMenu}>
          <div className={styles.subMenuLabelContainer}>
            <a className={styles.subMenuLabel} href={subMenu.path}>
              {subMenu.title}
            </a>
            <button
              className={classnames(styles.subMenuChevron, {
                [styles.active]: opened === index
              })}
              onClick={() => onClickHandler(index)}
            >
              <img src={chevronIcon} alt="chevron icon" />
            </button>
          </div>
          <ul
            className={classnames(styles.subMenuList, {
              [styles.active]: isDesktop || opened === index
            })}
          >
            {subMenu.children.map(({path, title}) => (
              <li key={title + path}>
                <a href={path}>{title}</a>
              </li>
            ))}
          </ul>
        </div>
      )),
    [subMenus, opened, isDesktop, onClickHandler]
  );

  return (
    <div
      className={classnames(styles.subMenus, {[styles.focus]: isFocused})}
      onMouseEnter={keepFocused}
      onMouseLeave={hide}
      onKeyDown={hideOnEsc}
    >
      <MasonryLayout isFocused={isFocused} isDesktop={isDesktop}>
        {subMenusEl}
      </MasonryLayout>
    </div>
  );
}

SubMenus.propTypes = {
  isFocused: PropTypes.bool,
  isActive: PropTypes.bool,
  hide: PropTypes.func.isRequired,
  keepFocused: PropTypes.func.isRequired,
  subMenus: PropTypes.array.isRequired
};
